import { render, staticRenderFns } from "./DocumentTypeButtons.vue?vue&type=template&id=4ef34021&scoped=true"
import script from "./DocumentTypeButtons.vue?vue&type=script&lang=js"
export * from "./DocumentTypeButtons.vue?vue&type=script&lang=js"
import style0 from "./DocumentTypeButtons.vue?vue&type=style&index=0&id=4ef34021&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef34021",
  null
  
)

export default component.exports